import type { ItemizedPercentileListValue } from './types.d';

export const getRecordTotal = (value: ItemizedPercentileListValue) => {
  return Object.values(value?.props ?? {}).reduce(
    (sum, item) => Number(sum) + Number(item?.value ?? 0),
    0
  );
};

export const isPercentileRecordTotal100 = (
  value: ItemizedPercentileListValue
) => {
  return getRecordTotal(value) == 100;
};
